<template>
  <div>
    <ul>
      <li v-for="(item) in list" :key="item.id" class="mb-2 last:mb-0" :class="{ 'text-ccc': disabled }">
        <sort-item :item="item" :index="item.index" @click.native="onChangeState(item)" />
      </li>
    </ul>
  </div>
</template>

<script>
import SortItem from '@/questions/choice/SortItem'

export default {
  name: 'Sort',
  components: { SortItem },
  changeExpr: 'changeExpr',
  computed: {
    list() {
      const list = this.issue.value.map((item, index) => {
        return Object.assign(item,{index})
      })
      if (!this.issue.disableChangePosition) {
        return list
      }
      return list.sort((a, b) => a.originPosition - b.originPosition)
    },
    changeExpr() {
      let items = this.issue.value.filter(item => item.select)
      return items.map(item => item.id + '|' + item.value).join('-')
    },
    disabled() {
      return this.issue.value.slice().filter(i => i.select).length >= this.issue.max_choice
    }
  },
  methods: {
    onChangeState(item) {
      let selects = this.issue.value.slice()
      if (!item.select) {
        let len = selects.filter(i => i.select).length
        if (len >= this.issue.max_choice) return
      }
      let index = selects.findIndex(i => i.id === item.id)
      selects.splice(index, 1)
      item.select = !item.select
      let insertIndex = -1
      for (let i = 0; i < selects.length; i++) {
        let val = selects[i]
        if (!val.select) {
          insertIndex = i
          break
        }
      }
      if (insertIndex !== -1) {
        selects.splice(insertIndex, 0, item)
      } else {
        selects.push(item)
      }
      this.issue.value = selects
    }
  }
}
</script>

<style scoped></style>
